<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : unnecessaryErrors.additional_email }"
      )
        .form-elem__title Адрес электронной почты
        .form-elem__body
          input.input.input_full(
            type="email"
            v-model="localAdditionalEmail"
            v-on:keyup="keymonitor"
            maxlength="50"
          )
          .form-elem__description На этот адрес будут приходить последние новости и уведомления о статусе вашей заявки

    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.phone }"
      )
        .form-elem__title Телефон
        .form-elem__body
          input.input.input_full(
            type="tel"
            v-model="localPhone"
            v-on:keyup="keymonitor"
            v-mask="'+ 7 ### ### ## ##'"
          )

    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : unnecessaryErrors.work_phone }"
      )
        .form-elem__title Рабочий телефон
        .form-elem__body
          input.input.input_full(
            type="tel"
            v-model="localWorkPhone"
            v-on:keyup="keymonitor"
            v-mask="'8 ### ### ## ##'"
          )
</template>
<script>
export default {
  name: "FormContacts",
  components: {},
  props: {
    additionalEmail: {
      type: [String, Object],
      default: ""
    },
    phone: {
      type: [String, Object],
      default: ""
    },
    workPhone: {
      type: [String, Object],
      default: ""
    },
    requireErrors: {
      type: Object,
      default: () => ({})
    },
    unnecessaryErrors: {
      type: Object,
      default: () => ({})
    },
    keymonitor: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    localAdditionalEmail: {
      get() {
        return this.additionalEmail;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "additional_email"]);
      }
    },
    localPhone: {
      get() {
        return this.phone;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "phone"]);
      }
    },
    localWorkPhone: {
      get() {
        return this.workPhone;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "work_phone"]);
      }
    }
  }
};
</script>
